import { Component, HostBinding, Input, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ChangeRecordLogicService } from '@app/logic/change-records/change-record.logic-service';
import { DesignSchemesLogicService, IDesignSchemeMappedItem } from '@app/logic/design-schemes';
import { provideParentForm } from '@app/shared/providers/provide-parent-form.provider';
import { DESIGN_SCHEME_LINE_STATUS_ENUM, IDesignSchemeLineDto } from '@classictechsolutions/hubapi-transpiled-enums';
import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { take } from 'rxjs';

@Component({
    selector: 'cb-design-scheme-assigned-changes',
    templateUrl: './design-scheme-assigned-changes.component.html',
    styleUrls: ['./design-scheme-assigned-changes.component.scss'],
    viewProviders: [provideParentForm()],
    standalone: false
})
export class DesignSchemeAssignedChangesComponent implements OnInit {
    @HostBinding('class') class = 'flex-row';
    @Input() public mappedItem: IDesignSchemeMappedItem;
    @Input() public parentForm: NgForm;

    public DESIGN_SCHEME_LINE_STATUS_ENUM = DESIGN_SCHEME_LINE_STATUS_ENUM;

    public assignedChangeRecords: IDesignSchemeLineDto[] = [];
    public unassignedChangeRecords: IDesignSchemeLineDto[] = [];

    constructor(
        public readonly logicService: DesignSchemesLogicService,
        public readonly changeRecordLogicService: ChangeRecordLogicService
    ) {}

    public ngOnInit(): void {
        this.loadAssignedChangeRecords();
        this.loadUnassignedChangeRecords();
    }

    public drop(event: CdkDragDrop<IDesignSchemeLineDto[]>): void {
        if (event.previousContainer === event.container) {
            if (event.previousIndex !== event.currentIndex) {
                moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
            }
        } else {
            transferArrayItem(
                event.previousContainer.data,
                event.container.data,
                event.previousIndex,
                event.currentIndex
            );
        }

        this.mappedItem.designSchemeLines = this.assignedChangeRecords;
    }

    private loadAssignedChangeRecords(): void {
        this.assignedChangeRecords = this.mappedItem.designSchemeLines;
        if (!this.assignedChangeRecords || this.assignedChangeRecords.length < 1) {
            this.assignedChangeRecords = [];
        }
    }

    private loadUnassignedChangeRecords(): void {
        this.changeRecordLogicService
            .getUnassignedChangeRecords(this.mappedItem.lotId)
            .pipe(take(1)).subscribe((results: any) => {
                this.unassignedChangeRecords = results;
                if (!this.unassignedChangeRecords || this.unassignedChangeRecords.length < 1) {
                    this.unassignedChangeRecords = [];
                }
            });
    }
}
